'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { logCallingError } from 'calling-error-reporting/report/error';
import CalleeError from './CalleeError';
import { jsx as _jsx } from "react/jsx-runtime";
export default class CalleeErrorBoundary extends PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      appName
    } = this.props;
    logCallingError({
      errorMessage: 'Error caught in CallNumbersPopover',
      extraData: {
        error,
        errorInfo,
        appName
      },
      tags: {
        plainErrorMessage: error.message,
        component: 'CallNumbersPopover'
      }
    });
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_jsx(CalleeError, {
        appName: this.props.appName
      });
    }
    return this.props.children;
  }
}
CalleeErrorBoundary.propTypes = {
  appName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};